import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_HOME_ORGANISATIONS,
  FETCH_HOME_ORGANISATIONS_ERROR,
  SET_HOME_ORGANISATIONS,
} from '../constants';

const homeOrganisations = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_HOME_ORGANISATIONS),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/organisations?${`&since=${
          encodeURIComponent(state$.value.home.sinceDate)
          }&until=${encodeURIComponent(state$.value.home.untilDate)}`}&v=${
          process.env.REACT_APP_VERSION
          }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_HOME_ORGANISATIONS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_HOME_ORGANISATIONS_ERROR,
            error,
          })
        )
      )
    )
  );

export default homeOrganisations;
